// ============================================
// CotizarEnvio — El equipo captura el envío por peso de una distribuidora
// Ruta: /cotizar-envio?c=<cart_id>&t=<firma>  (link del correo a distribucion@)
// ============================================

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SEO from '../components/SEO';
import { getQuoteRequest, respondQuoteRequest } from '../services/medusa/shippingQuote';
import { formatAmount } from '../utils/money';
import './CotizarEnvio.css';

export default function CotizarEnvio() {
  const [params] = useSearchParams();
  const c = params.get('c') || '';
  const t = params.get('t') || '';

  const [info, setInfo] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [form, setForm] = useState({ amount: '', weight_kg: '', note: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (!c || !t) {
      setLoadError('Link incompleto.');
      return;
    }
    getQuoteRequest(c, t)
      .then((data) => {
        setInfo(data);
        if (data.quote) {
          setForm({
            amount: String(data.quote.amount ?? ''),
            weight_kg: data.quote.weight_kg ? String(data.quote.weight_kg) : '',
            note: data.quote.note || '',
          });
        }
      })
      .catch((err) => setLoadError(err.message));
  }, [c, t]);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const data = await respondQuoteRequest({ c, t, ...form });
      setInfo(data);
      setSaved(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cotizar-root">
      <SEO title="Calcular envío" noindex />
      <div className="cotizar-card">
        <p className="cotizar-kicker">Distribución · envío por peso</p>

        {loadError && <p className="cotizar-error">{loadError}</p>}
        {!info && !loadError && <p className="cotizar-muted">Cargando pedido…</p>}

        {info && (
          <>
            <h1 className="cotizar-title">{info.customer.company || info.customer.name}</h1>
            <p className="cotizar-muted">
              {info.customer.name} · {info.customer.email} · CP {info.postal_code}
            </p>
            {info.note && <p className="cotizar-note">“{info.note}”</p>}

            <ul className="cotizar-items">
              {info.items.map((it, i) => (
                <li key={i}>
                  <span>{it.quantity} ×</span> {it.title}
                </li>
              ))}
            </ul>
            <p className="cotizar-subtotal">Subtotal ${formatAmount(info.subtotal)}</p>

            {info.completed ? (
              <p className="cotizar-ok">Este pedido ya se pagó.</p>
            ) : info.changed ? (
              <p className="cotizar-error">
                La distribuidora cambió su carrito después de pedir el cálculo. Espera a que pida uno nuevo.
              </p>
            ) : (
              <form className="cotizar-form" onSubmit={onSubmit}>
                <label>
                  Peso (kg)
                  <input name="weight_kg" type="number" step="0.1" min="0" value={form.weight_kg} onChange={onChange} />
                </label>
                <label>
                  Costo de envío (MXN)
                  <input name="amount" type="number" step="0.01" min="0" required value={form.amount} onChange={onChange} />
                </label>
                <label className="cotizar-wide">
                  Nota para la distribuidora (opcional)
                  <input name="note" type="text" maxLength={500} value={form.note} onChange={onChange} placeholder="Ej. 2 cajas, DHL Express" />
                </label>
                {error && <p className="cotizar-error cotizar-wide">{error}</p>}
                {saved ? (
                  <p className="cotizar-ok cotizar-wide">
                    Listo. Le avisamos a la distribuidora que su pedido está listo para pago
                    (envío ${formatAmount(info.quote?.amount)}).
                  </p>
                ) : info.status === 'quoted' ? (
                  <p className="cotizar-muted cotizar-wide">
                    Ya cotizado en ${formatAmount(info.quote?.amount)}. Puedes corregirlo y volver a guardar.
                  </p>
                ) : null}
                <button type="submit" className="cotizar-btn cotizar-wide" disabled={saving}>
                  {saving ? 'Guardando…' : 'Guardar envío y avisar a la distribuidora'}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}
